const normalize = (value) => String(value ?? "").normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "").replace(/đ/gi, "d").toLowerCase().trim().replace(/\s+/g, " ");
const compact = (value) => value.replace(/[^\p{L}\p{N}]/gu, "");

// Shared by the renderer and the native offline catalog. Lower ranks appear first.
const getDesktopProductSearchRank = (product, query) => {
  const term = normalize(query);
  const compactTerm = compact(term);
  if (!compactTerm || term.length > 200) return null;
  const name = normalize(product.name);
  const code = normalize(product.id);
  const barcode = normalize(product.barcode);
  const compactName = compact(name);
  if (name.startsWith(term) || compactName.startsWith(compactTerm)) return 0;
  const initials = (name.match(/[\p{L}\p{N}]+/gu) || []).map((word) => Array.from(word)[0]).join("");
  if (/^[\p{L}\p{N}]{2,}$/u.test(term) && initials.startsWith(term)) return 1;
  const tokens = term.split(" ");
  if (name.includes(term) || compactName.includes(compactTerm) ||
    tokens.every((token) => name.includes(token) || compactName.includes(compact(token)))) return 2;
  if ([code, barcode].some((field) => field.includes(term) || compact(field).includes(compactTerm))) return 3;
  return null;
};

module.exports = { getDesktopProductSearchRank };
